import { render } from "./CommentCard.vue?vue&type=template&id=70e15a3e"
import script from "./CommentCard.vue?vue&type=script&lang=ts"
export * from "./CommentCard.vue?vue&type=script&lang=ts"
script.render = render

export default script